import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import ButtonMiradorOrange, { ButtonContainer } from 'components/Button';
import Colors from 'constants/Colors';
import Loader from 'components/Loader';
import Icon from 'components/Icon';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalLoaderContext, GlobalOperationContext } from 'store/context';

import { ButtonContent, IconButtons } from './styles';

export default function Page6({ match }) {

  const loading = useContext(GlobalLoaderContext);
  const operationContext = useContext(GlobalOperationContext);
  const history = useHistory();
  const [question, setQuestion] = useState({});
  const [options, setOptions] = useState([]);
  const [selectedItens, setSelectedItens] = useState([]);
  const idOperation = match.params.idOperation;
  //redirect
  const goToLoginPage = () => {
    history.push('/login');
  };
  const goBack = () => {
    history.goBack();
  }

  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [initial, setInitial] = useState({});

  /*   const verifyPattern = (fieldType) => {
  
            if (fieldType) {
              let m;
              if (fieldType == "percentage") {
                m = masks.getPercentage("BR-brazil", 2 || null, "5000000" || "9999", "7900" || "0");
              }else{
                m = masks.getMask(fieldType || null, "BR-brazil", 2 || null,"9999999" || null,"500000" || null, "7900" || null)
              }
              return m;
            }
           
    }
   */
  let messageHeader = () => {
    return (
      <><div>
        <h2 style={{ fontWeight: "bold", marginTop: "10px" }}>
          Quais são os seus principais
          <br />
          objetivos ao investir em
          <br />
          previdência privada?
        </h2>
      </div>
      </>
    );
  }

  let messageBodyTop = () => {
    return (
      <><div>
        <h5 style={{ fontWeight: "bold" }}>
          <div style={{ textTransform: "capitalize", display: "inline-flex" }}>{`${initial.name[0]}`}</div> digite aqui o código de verificação
          <br />
          que acabamos de te enviar via e-mail.
        </h5>
      </div>
      </>
    );
  }

  let messageBodyBottom = () => {
    return (
      <><div>
        <h6 style={{ cursor: "pointer" }}
          onClick={() => {
            history.replace({ pathname: '/embed/page4', state: { page4DataBack: { ...initial } } });
          }}>
          Quero trocar meu e-mail
        </h6>
      </div>
      </>
    );
  }

  const handleResend = () => {
 
  }

  useEffect(() => {
    //loading.start();
    async function loadContent() {
      //Recuperando question e opções de resposta para question 199
      const qst = operationContext.add_response.operationQuestionnaire.find(qst => qst.idQuestion === 199);
      setQuestion(qst);
      setOptions(qst.answerOptions);
    }
    loadContent();
    //loading.stop();
  }, [initial])

  const handleSubmit = async () => {

    if (selectedItens.length < 1) {
      mc.error("Selecione ao menos uma opção");
      return;
    }

    // preenchendo resposta
    let qst = {
      idAnswerOption: selectedItens.map((answer) => answer.idAnswerOption?.toString()),
      idDomainPersonRole: question.idDomainPersonRole,
      idQuestion: question.idQuestion,
      idQuestionnaire: question.idQuestionnaire,
      questionDomain: question.questionDomain,
      textQuestionAnswer: selectedItens.map((answer) => answer.answerOptionDescription)
    };

    //salvando resposta no contexto de operação
    const index = operationContext.add2_request.operationQuestionnaire.findIndex(element => element.idQuestion === qst.idQuestion);
    operationContext.add2_request.operationQuestionnaire[index] = qst;
    localStorage.setItem("fitOperation", JSON.stringify(operationContext));
    
    history.push(`/embed/page7/${idOperation}`);
  }

  const handleSelect = (item) => {
    const isSelected = selectedItens.includes(item);
    if (isSelected) {
      const filteredItems = selectedItens.filter(element => element !== item);
      setSelectedItens(filteredItems);
    } else {
      setSelectedItens([...selectedItens, item]);
    }
  }

  const normalizeStr = str => {
    // removendo acentuaçao e espaços
    let strAux = str.normalize("NFD").replace(/\p{Diacritic}/gu, "")
    return strAux.replace(/\s+/g, '');
  }

  return (
    <>
      <Row>
        <Col>
        </Col>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={(e) => { e.stopPropagation(); e.preventDefault() }}
            style={{ opacity: 0, width: 0, height: 0 }}>
          </button>
        </Col>
      </Row>

      <Row><h5 style={{ margin: "0px 0px 0px 15px", fontWeight: "normal" }} onClick={() => { history.replace({ pathname: '/embed/page5', state: { page5DataBack: { ...initial } } }) }}>voltar</h5></Row>
      <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
      <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>
      <Row>
        <div style={{ width: "90%", marginLeft: "5%", marginRight: "5%", boxShadow: "0px 5px 10px 8px rgba(238,240,253)" }}>
          <Row style={{ placeContent: "center" }}><h5>Selecione uma ou mais opções</h5></Row>
          <Row style={{ justifyContent: "space-between", margin: "1%" }}>

            {options.map((item, index) =>
              <IconButtons
                key={index}
                selected={selectedItens.includes(item)}
                onClick={() => handleSelect(item)}
              >
                <Icon name={normalizeStr(item.answerOptionDescription)} />
                <p>{item.answerOptionDescription}</p>
              </IconButtons>
            )}

          </Row>
          <Row style={{ textAlign: "center", display: "contents", placeContent: "center" }}>
            <Col>
              <h5>
                O Plano MIRADOR Família é uma opção
                inteligente e segura de você juntar dinheiro para
                realizar seus sonhos de longo prazo.
                <br />
                Por isso, o ideal é que pense nos seus planos para
                daqui, no mínimo dez anos.
              </h5>
            </Col>
          </Row>
        </div>
      </Row>

      <ButtonContainer style={{ justifyContent: "center" }}>
        <ButtonContent>
          <ButtonMiradorOrange
            type="submit"
            primary
            id="btnSubmit"
            onClick={() => handleSubmit()}
          >
            CONFIRMAR
          </ButtonMiradorOrange>
        </ButtonContent>
      </ButtonContainer>
    </>
  )
}